import { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { TextField } from '@mui/material';

import { patchCampaign } from 'store/actions/campaigns';

import { Dialog } from 'common/components';

const RenameCampaignDialog = ({
  campaignName,
  isPending,
  isRenameDialogOpen,
  setIsRenameDialogOpen,
}) => {
  const dispatch = useDispatch();

  const { campaignUuid } = useParams();
  const [campaignNameValue, setCampaignNameValue] = useState('');

  const handleConfirm = async () => {
    await dispatch(
      patchCampaign(campaignUuid, {
        name: campaignNameValue,
      })
    );

    setCampaignNameValue('');
    setIsRenameDialogOpen(false);
  };

  const handleDialogClose = () => {
    setCampaignNameValue('');
    setIsRenameDialogOpen(false);
  };

  return (
    <Dialog
      handleConfirm={handleConfirm}
      handleDialogClose={handleDialogClose}
      isDialogOpen={isRenameDialogOpen}
      title="Rename Campaign"
      disabledButton={isPending}
    >
      <TextField
        fullWidth
        placeholder="Rename Campaign"
        onChange={event => setCampaignNameValue(event.target.value)}
        type="text"
        defaultValue={campaignName}
      />
    </Dialog>
  );
};

RenameCampaignDialog.defaultProps = {
  campaignName: '',
};

RenameCampaignDialog.propTypes = {
  campaignName: PropTypes.string,
  isPending: PropTypes.bool.isRequired,
  isRenameDialogOpen: PropTypes.bool.isRequired,
  setIsRenameDialogOpen: PropTypes.func.isRequired,
};

export default RenameCampaignDialog;
